import clsx from 'clsx';
import { Fragment } from 'react/jsx-runtime';

import type { Icons } from 'components/Icon/icons';

import styles from './OverlayStepBar.module.css';

import { Icon } from 'components';

type StepType = {
  label: string;
  status: 'inactive' | 'active' | 'checked';
};

export interface OverlayStepBarProps {
  steps: StepType[];
}

const ICON_NAMES: (keyof typeof Icons)[] = [
  'MiniCheck',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
];

export const OverlayStepBar = ({ steps }: OverlayStepBarProps) => {
  if (steps.length > ICON_NAMES.length - 1) {
    throw new Error("The 'steps' array must contain no more than 9 objects.");
  }

  return (
    <div className={styles['overlay-step-bar__container']}>
      {steps.length < ICON_NAMES.length &&
        steps.map(({ label, status }, index) => (
          <Fragment key={`${index}_${label}`}>
            {index !== 0 && <Icon name={'CheveronRight'} size={16} className={styles['overlay-step-bar__separator']} />}
            <span className={clsx(styles[`overlay-step-bar__step`], styles[`overlay-step-bar__step--${status}`])}>
              <span className={styles['overlay-step-bar__step-bullet']}>
                <Icon name={status === 'checked' ? ICON_NAMES[0] : ICON_NAMES[index + 1]} size={24} />
              </span>
              {label}
            </span>
          </Fragment>
        ))}
    </div>
  );
};
